"use client";

import { c as _c } from "react/compiler-runtime";
import clsx from "clsx";
import { CompanyProduct } from "@/components/Products/CompanyProduct/CompanyProduct.component";
import { FallbackProduct } from "@/components/Products/FallbackProduct/FallbackProduct.component";
import { QuarterlyProduct } from "@/components/Products/QuarterlyProduct/QuarterlyProduct.component";
import { YearlyProduct } from "@/components/Products/YearlyProduct/YearlyProduct.component";
import { usePaywall } from "@/contexts/paywall/paywall.context";
type ProductsContainerProps = {
  readonly variant?: "paywall" | "product-page";
  readonly position?: string;
  readonly promoPosition?: string;
};
export function ProductsContainer(t0) {
  const $ = _c(23);
  const {
    variant,
    position,
    promoPosition
  } = t0;
  const {
    quarterlyProduct,
    yearlyProduct
  } = usePaywall();
  let t1;
  if ($[0] !== position || $[1] !== promoPosition || $[2] !== variant || $[3] !== yearlyProduct) {
    t1 = yearlyProduct !== null && <YearlyProduct className={clsx(variant === "paywall" && "gap-1 py-2 lg:order-1 lg:w-1/3", variant === "product-page" && "lg:order-1 lg:w-1/3")} position={`${position}-bbtn-y`} promoPosition={promoPosition} size={variant === "paywall" ? "medium" : "large"} />;
    $[0] = position;
    $[1] = promoPosition;
    $[2] = variant;
    $[3] = yearlyProduct;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== position || $[6] !== promoPosition || $[7] !== quarterlyProduct || $[8] !== variant) {
    t2 = quarterlyProduct !== null && <QuarterlyProduct className="lg:order-0 lg:w-1/3" position={`${position}-bbtn-q`} promoPosition={promoPosition} size={variant === "paywall" ? "medium" : "large"} />;
    $[5] = position;
    $[6] = promoPosition;
    $[7] = quarterlyProduct;
    $[8] = variant;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] !== position || $[11] !== quarterlyProduct || $[12] !== variant || $[13] !== yearlyProduct) {
    t3 = yearlyProduct === null && quarterlyProduct === null && <FallbackProduct className="lg:order-0 lg:w-1/3" position={`${position}-bbtn-fallb`} size={variant === "paywall" ? "medium" : "large"} />;
    $[10] = position;
    $[11] = quarterlyProduct;
    $[12] = variant;
    $[13] = yearlyProduct;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  const t4 = `${position}-bbtn-co`;
  const t5 = `${variant === "paywall" ? "medium" : "large"}`;
  let t6;
  if ($[15] !== t4 || $[16] !== t5) {
    t6 = <CompanyProduct className="lg:order-2 lg:w-1/3" position={t4} size={t5} />;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== t1 || $[19] !== t2 || $[20] !== t3 || $[21] !== t6) {
    t7 = <div className="mx-auto flex w-full max-w-5xl flex-col gap-4 lg:flex-row lg:justify-center lg:gap-2">{t1}{t2}{t3}{t6}</div>;
    $[18] = t1;
    $[19] = t2;
    $[20] = t3;
    $[21] = t6;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  return t7;
}